import React from 'react';
import * as Sentry from "@sentry/react";
import ID from './UUID';
import { FiPlus, FiPlusCircle, FiX, FiImage, FiTrash2, FiMove, FiFileText } from 'react-icons/fi';
import { Flex, Box, Button, Heading } from 'rebass';
import { Input, Select, Label, Textarea} from '@rebass/forms';
import ReactModal from 'react-modal';
import helpers from 'utils/helpers';
import helpersScreener from 'utils/helpers-screener';
import { withToastManager } from 'react-toast-notifications';
import { List, arrayMove } from 'react-movable';
import ReactTooltip from 'react-tooltip';
import { SCREENER_Q_DQ_REDIRECT_PREFIX, SCREENER_QDQS_REJECT, SCREENER_QDQS_ACCEPT } from 'utils/constants';
import TooltipIcon from 'components/TooltipIcon';
import NiceModal from 'components//NiceModal';
import { cloneDeep } from 'lodash';

class DynamicOptionList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            element: this.props.element,
            data: this.props.data,
            dirty: false,
            showAddBulkOptions: false
        };

        this.addOptionsBulk = this.addOptionsBulk.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleRemoveOptions = this.handleRemoveOptions.bind(this);
    }

    _setValue(text) {
        return text.replace(/[^A-Z0-9]+/gi, '_').toLowerCase();
    }

    editOption(option_index, e) {
        const this_element = cloneDeep(this.state.element);
        const val =
            this_element.options[option_index].value !== this._setValue(this_element.options[option_index].text)
                ? this_element.options[option_index].value
                : this._setValue(e.target.value);

        this_element.options[option_index].text = e.target.value;
        this_element.options[option_index].value = val;
        this.setState({
            element: this_element,
            dirty: true
        });
    }

    editValue(option_index, e) {
        const this_element = this.state.element;
        const val = e.target.value === '' ? this._setValue(this_element.options[option_index].text) : e.target.value;
        this_element.options[option_index].value = val;
        this.setState({
            element: this_element,
            dirty: true
        });
    }

    // eslint-disable-next-line no-unused-vars
    editOptionCorrect(option_index, e) {
        const this_element = this.state.element;
        if (this_element.options[option_index].hasOwnProperty('correct')) {
            delete this_element.options[option_index].correct;
        } else {
            this_element.options[option_index].correct = true;
        }
        this.setState({ element: this_element });
        this.props.updateElement.call(this.props.preview, this_element);
    }

    editOptionQualification(option_index, e) {
        const this_element = this.state.element;
        const optionValue = e.target.value;

        //console.log('has qualification prop', this_element.options[option_index].hasOwnProperty('qualification'));
        //console.log('qualification option value', optionValue);

        this_element.options[option_index].qualification = optionValue;

        //console.log('updating element', this_element);
        this.setState({ element: this_element });
        this.props.updateElement.call(this.props.preview, this_element);
    }

    editOptionType(option_index, e) {
        const this_element = this.state.element;
        const optionValue = e.target.value;

        this_element.options[option_index].type = optionValue;

        this.setState({ element: this_element });
        this.props.updateElement.call(this.props.preview, this_element);
    }

    updateOption() {
        const this_element = this.state.element;
        // to prevent ajax calls with no change
        if (this.state.dirty) {
            this.props.updateElement.call(this.props.preview, this_element);
            this.setState({ dirty: false });
        }
    }

    editOptionReportingValue(option_index, e) {
        console.log(option_index, e)
        const this_element = this.state.element;

        this_element.options[option_index].reporting_value = e.target.value;

        this.setState({
            element: this_element,
            dirty: true
        });
    }

    addOption(index, optionDefaults, skipXhrSave) {
        const this_element = this.state.element;
        let opt = {
            value: optionDefaults.value ? optionDefaults.value : '',
            text: optionDefaults.text ? optionDefaults.text : '',
            key: ID.uuid()
        };
        //console.log('add option index', index, this_element.options)
        if ('Matrix' == this.state.element.element) {
            const has_columns = this_element.options.filter(o => o && o.type && o.type == 'column');

            //console.log('...adding', has_columns, opt.type)

            if (has_columns && has_columns.length) {
                opt.type = 'column';
            } else {
                opt.type = 'row';
            }


        }

        this_element.options.splice(index + 1, 0, opt);

        if (!skipXhrSave) {
            this.props.updateElement.call(this.props.preview, this_element);
        }
    }

    removeOption(index, skipXhrSave) {
        //console.log('deleting', index, skipXhrSave)
        const this_element = this.state.element;
        this_element.options.splice(index, 1);

        if (skipXhrSave) {
            //console.log('skipping delete save')
        } else {
            this.props.updateElement.call(this.props.preview, this_element);
        }
    }


    rearrangeOptions(oldIndex, newIndex) {
        const this_element = cloneDeep(this.state.element);

        this_element.options = arrayMove(this_element.options, oldIndex, newIndex)

        this.props.updateElement.call(this.props.preview, this_element);
    }

    addOptionsBulk() {

        this.setState({showAddBulkOptions: false});

        const that = this;
        let new_options = [];

        if (this.state.addBulkOptionsValue) {
            let arr = this.state.addBulkOptionsValue.split(/\r?\n/);
            if (arr.length) {
                arr.forEach(text_line => {
                    text_line = text_line.trim();
                    if (text_line && text_line.length > 0) {
                        new_options.push({
                            text: text_line,
                            value: text_line
                        });
                    }
                })
            }
        }

        if (new_options) {
            const skipXhrSave = true;
            const this_element = this.state.element;
            //console.log("OPTS", this_element.options)
            this_element.options.removeIf(o => o && o.text == "");

            new_options.forEach((new_option, key) => {
                that.addOption(that.state.element.options.length - 1, new_option, skipXhrSave);
            });


            this.props.updateElement.call(this.props.preview, this_element);
        }
    }

    componentDidMount() {
    }

    componentDidCatch(error, errorInfo) {
        Sentry.captureException(error);
    }

    componentWillReceiveProps(nextProps) {

        console.log('dynamic-option-list - componentWillReceiveProps');
        let this_element = cloneDeep(nextProps.element);
        if (this.state.dirty === false) this.setState({ element: this_element });
    }

    handleImageChange(error, value, option_index) {

        if (error){
            alert(body);
            return;
        }

        // if "value" is empty we are deleting the image
        if (value) {
            const { toastManager } = this.props;
            toastManager.add('Successfully uploaded image', {
                appearance: 'success',
                autoDismiss: true
            });
        }

        const this_element = this.state.element;

        this_element.options[option_index].image = value;

        this.setState({ element: this_element }, () => {
            this.props.updateElement.call(this.props.preview, this_element);
        });
    }

    handleImageUploadClick(option, option_index) {

        if (option.image) {
            helpersScreener.imageRemove(option.image, (err) => { console.log(err); } );
        }

        const callbackUploading = () => {
            const { toastManager } = this.props;
            toastManager.add('Image uploading...', {
                appearance: 'info',
                autoDismiss: true
            });
        }

        helpersScreener.imageUploadButton(`option-image-${option.key}`, callbackUploading, (error, image_url) => {
            this.handleImageChange(error, image_url, option_index)
        });
    }

    isNonStandardOption(option) {
        return option.is_add_other || option.is_none_of_the_above;
    }

    renderNonStandardOption(option, index) {
        let element;
        if (option.is_add_other) {
            element = <Input
                //tabIndex={index + 1}
                type="text"
                name={`text_${index}`}
                placeholder={`"Other" answer option`}
                value={option.text}
                disabled={true}
                //className="theme-input theme-input-simple"
                className="theme-input"
            />;
        } else if (option.is_none_of_the_above) {
            element = <Input
                //tabIndex={index + 1}
                type="text"
                name={`text_${index}`}
                placeholder={`"None of the above" answer option`}
                value={option.text}
                disabled={true}
                //className="theme-input theme-input-simple"
                className="theme-input"
            />;
        }

        return element;
    }

    shouldShowReportingValues(props) {
        return props.canHaveOptionValue && props.element.reporting_values;
    }

    handleRemoveOptions() {
      const this_element = this.state.element;
      this_element.options = [];
      this.setState({element: this_element});
      this.props.updateElement.call(this.props.preview, this_element);
    }

    render() {

        const all_pages = this.state.data;
        const num_pages = all_pages.length;
        let additional_qual_disqual_redirects = [];

        let q_on_page_number;
        let page_number;
        for (let page_index = 0; page_index < num_pages; page_index++) {
            page_number = page_index + 1;
            // find which page this element is on
            let q_found = all_pages[page_index].find( q => q.id == this.state.element.id);
            if (q_found) {
                q_on_page_number = page_number;
            }

            // only allow redirect to pages after the page current element was found on
            if (page_number > q_on_page_number) {
                additional_qual_disqual_redirects.push(
                    <option value={`${SCREENER_Q_DQ_REDIRECT_PREFIX}${page_number}`}>
                        Skip to page {page_number}
                    </option>
                )
            }
        }

        const this_element = this.state.element;
        //console.log('DOL', this.state)
        if (this.state.dirty) {
            this.state.element.dirty = true;
        }

        let isMatrixAndMissingColumnOption = false;
        let options = [];
        if ('Matrix' == this.state.element.element) {
            options = this.state.element.options.sort((a, b) => {
                if(a.type < b.type) { return 1; }
                if(a.type > b.type) { return -1; }
                return 0;
            });

            isMatrixAndMissingColumnOption = true;
            this.state.element.options.forEach(o => {
                if (o && o.type == 'column') {
                    isMatrixAndMissingColumnOption = false;
                }
            })
        } else {
            options = this.state.element.options;
        }


        return (
            <div className="editor-options-container">
                <div>
                    <Flex mx={-2} mt={3}>
                        <Box px={2} width={1/2}>
                            <Flex sx={{gridGap: 2}}>
                                <Box sx={{width: '100%'}} width={this.shouldShowReportingValues(this.props) ? '2/3' : '1'}>
                                    <Label className='quiet'>Options</Label>
                                    {isMatrixAndMissingColumnOption == true &&
                                        <Box fontSize={1} mt={2} mb={2}>
                                            <span className={'bg-error rounded red fs-13'} style={{padding: '4px 8px'}}>
                                                Warning: At least 1 option must be a Column.
                                            </span>
                                        </Box>
                                    }
                                </Box>
                                {(this.shouldShowReportingValues(this.props)
                                    && ['RadioButtons', 'Dropdown', 'Checkboxes', 'Matrix'].includes(this.state.element.element)) && (
                                        <Box width={1/3}>
                                            <Label className='quiet'>
                                                Reporting Value
                                                <TooltipIcon for={`tooltip-reporting_value`} margin="2px 0 0 8px" />
                                            </Label>
                                        </Box>
                                )}
                            </Flex>
                        </Box>
                        {/*this.props.canHaveOptionValue && (
                            <div className="col-sm-2">
                                <b>Value</b>
                            </div>
                        )*/}
                        {/* this.props.canHaveOptionValue && this.props.canHaveOptionCorrect &&
                          <div className="col-sm-4"><b>Correct</b></div> */}
                        {(this.props.canHaveOptionValue && this.props.element.qual_disqual
                            && ['RadioButtons', 'Dropdown', 'Checkboxes'].includes(this.state.element.element)) && (
                            <Box px={2} width={1/6}>
                                <Label className='quiet'>Q / DQ / Skip</Label>
                            </Box>
                        )}
                        <Box px={2} width={2/6}>

                        </Box>
                    </Flex>
                </div>

                <div>
                    <List
                      values={options}
                      onChange={({ oldIndex, newIndex }) => {
                          //console.log(oldIndex, newIndex)
                          this.rearrangeOptions(oldIndex, newIndex);
                      }}
                      renderList={({ children, props }) => <div {...props}>{children}</div>}
                      renderItem={({ value, index, props, isDragged, isSelected }) => {
                          let option = value;
                          /*return <li {...props}>
                              <Button
                                    data-movable-handle
                                    type='button'
                                    variant='link'
                                    className='muted'
                                    tabIndex={-1}
                                    style={{
                                        cursor: isDragged ? 'grabbing' : 'grab',
                                    }}
                                 >
                                    <FiMove />
                               </Button>
                              {value.value}
                          </li>;*/
                            const this_key = `edit_${option.key}`;
                            const val = option.value !== this._setValue(option.text) ? option.value : '';
                            return (
                                <div className="clearfix" key={this_key} {...props} tabIndex={-1}>
                                    <Flex mx={-1} mb={3}>
                                        <Box px={1} width={1/2}>
                                            <Flex sx={{gridGap: 2}}>
                                                <Box sx={{width: '100%'}} width={this.shouldShowReportingValues(this.props) ? '2/3' : '1'}>
                                                    {this.isNonStandardOption(option) ?
                                                        this.renderNonStandardOption(option, index)
                                                        :
                                                        <>
                                                            <Flex>
                                                                <Input
                                                                    //tabIndex={index + 1}
                                                                    type="text"
                                                                    name={`text_${index}`}
                                                                    placeholder="Option text"
                                                                    value={option.text}
                                                                    onBlur={this.updateOption.bind(this)}
                                                                    onChange={this.editOption.bind(this, index)}
                                                                    //className="theme-input theme-input-simple"
                                                                    className="theme-input"
                                                                />
                                                            </Flex>
                                                            {['RadioButtons', 'Checkboxes'].includes(this.state.element.element) && option.image &&
                                                                <Box mt={2} mb={2}>

                                                                    <Button mb={2} type='button' variant='tertiary-icon' tabIndex="-1"
                                                                        //onClick={()=> { if(confirm('Are you sure you want to delete this image?')) { this.handleImageChange('', index); }}}
                                                                        onClick={()=> { if(confirm('Are you sure you want to delete this image?')) { helpersScreener.imageRemove(option.image, (err) => { console.log(err); }); this.handleImageChange(false, '', index); }}}
                                                                        >
                                                                        <FiTrash2/> Delete Image
                                                                    </Button><br/>

                                                                    <img src={option.image} style={{maxWidth: '160px'}} />
                                                                </Box>
                                                            }
                                                        </>
                                                    }
                                                </Box>
                                                {this.shouldShowReportingValues(this.props) &&
                                                    ['RadioButtons', 'Dropdown', 'Checkboxes', 'Matrix'].includes(this.state.element.element) && (
                                                        <Box width={1/3}>
                                                            {!this.isNonStandardOption(option) &&
                                                                <Input
                                                                    //tabIndex={index + 1}
                                                                    type="text"
                                                                    name={`reporting_value_${index}`}
                                                                    placeholder=""
                                                                    value={option.reporting_value}
                                                                    onBlur={this.updateOption.bind(this)}
                                                                    onChange={this.editOptionReportingValue.bind(this, index)}
                                                                    //className="theme-input theme-input-simple"
                                                                    className="theme-input"
                                                                />
                                                            }
                                                        </Box>
                                                )}
                                            </Flex>
                                        </Box>
                                        {
                                            'Matrix' == this.state.element.element && (
                                                <Select
                                                    ml={1}
                                                    mr={2}
                                                    tabIndex={-1}
                                                    onChange={this.editOptionType.bind(this, index)}
                                                    value={
                                                        option.hasOwnProperty('type')
                                                            ? option.type
                                                            : ''
                                                    }
                                                    //className='theme-input theme-input-simple'
                                                    className='theme-input'
                                                    style={{width: '120px'}}
                                                >
                                                    <option value="row">Row</option>
                                                    <option value="column">Column</option>
                                                </Select>
                                        )}
                                        {this.props.canHaveOptionValue && this.props.element.qual_disqual &&
                                            ['RadioButtons', 'Dropdown'].includes(this.state.element.element) && (
                                                <Box px={2} width={1/6}>
                                                    <Select
                                                        onChange={this.editOptionQualification.bind(this, index)}
                                                        value={
                                                            option.hasOwnProperty('qualification')
                                                                ? option.qualification
                                                                : ''
                                                        }
                                                        //className='theme-input theme-input-simple'
                                                        className='theme-input'
                                                    >
                                                        <option value=""></option>
                                                        <option value={SCREENER_QDQS_ACCEPT}>Accept</option>
                                                        <option value={SCREENER_QDQS_REJECT}>Disqualify</option>
                                                        {additional_qual_disqual_redirects}
                                                    </Select>
                                                </Box>
                                            )}
                                        {this.props.canHaveOptionValue && this.props.element.qual_disqual &&
                                            ['Checkboxes'].includes(this.state.element.element) && (
                                                <Box px={2} width={1/6}>
                                                    <Select
                                                        onChange={this.editOptionQualification.bind(this, index)}
                                                        value={
                                                            option.hasOwnProperty('qualification')
                                                                ? option.qualification
                                                                : ''
                                                        }
                                                        //className='theme-input theme-input-simple'
                                                        className='theme-input'
                                                    >
                                                        <option value=""></option>
                                                        <option value="Must Select">Must Select</option>
                                                        <option value="May select">May Select</option>
                                                        <option value={SCREENER_QDQS_REJECT}>Disqualify</option>
                                                        {additional_qual_disqual_redirects}
                                                    </Select>
                                                </Box>
                                            )}
                                        <Box px={1} width={2/6}>
                                            {!this.isNonStandardOption(option) && (
                                                <div className="dynamic-options-actions-buttons">
                                                    <Button
                                                        data-movable-handle
                                                        type='button'
                                                        variant='secondary-gray'
                                                        className='secondary-icon'
                                                        tabIndex={-1}
                                                        style={{
                                                            cursor: isDragged ? 'grabbing' : 'grab',
                                                        }}
                                                        mr={2}
                                                     >
                                                        <FiMove />
                                                   </Button>
                                                    {['RadioButtons', 'Checkboxes'].includes(this.state.element.element) &&
                                                        <>
                                                            <Button type='button'
                                                                variant='secondary-gray'
                                                                className='secondary-icon'
                                                                mr={2}
                                                                 //onClick={(e) => { const url = prompt('Paste image URL:'); if (url) { this.handleImageChange(url, index); }}}
                                                                 onClick={(e) => { this.handleImageUploadClick(option, index); }}
                                                                 tabIndex="-1">
                                                                <FiImage  />
                                                            </Button>
                                                            <input type="file" id={`option-image-${option.key}`} accept="image/x-png,image/jpeg" hidden />
                                                        </>
                                                    }
                                                    {/*<Button
                                                        style={{margin:'0 8px 0 16px', fontSize: '18px'}}
                                                        variant='link'
                                                        onClick={this.addOption.bind(this, index)}
                                                        tabIndex="-1"
                                                    >
                                                        <FiPlusCircle />
                                                    </Button>*/}
                                                    {/*{index > 0 && (*/}
                                                        <Button
                                                            variant='secondary-gray'
                                                            className='secondary-icon'
                                                            onClick={this.removeOption.bind(this, index, false)}
                                                            tabIndex="-1"
                                                        >
                                                            <FiX />
                                                        </Button>
                                                    {/*)}*/}
                                                </div>
                                            )}
                                        </Box>
                                    </Flex>
                                </div>
                            );
                      }}
                    />
                </div>

                <Box mb={2}>
                    <Button
                        variant='link'
                        className='fs-13'
                        onClick={this.addOption.bind(this, this.state.element.options.length)}
                        tabIndex="-1"
                        mr={3}
                    >
                        <FiPlus style={{marginTop: '3px'}}/> Add option
                    </Button>

                    <Button
                        variant='link'
                        className='fs-13'
                        onClick={() => this.setState({showAddBulkOptions: true})}
                        tabIndex="-1"
                        >
                        <FiPlus style={{marginTop: '3px'}}/> Add bulk options
                    </Button>


                    {this.state.element.options.length > 0 && (
                    <Button
                        variant='link'
                        className='red'
                        onClick={()=> { if(confirm('Are you sure you want to remove all options?')) { this.handleRemoveOptions() }}}
                        tabIndex="-1"
                        ml={'24px'}
                        >
                        Remove all
                    </Button>) }
                </Box>

                <ReactModal
                    isOpen={this.state.showAddBulkOptions}
                    shouldCloseOnOverlayClick
                    onRequestClose={() => { this.setState({showAddBulkOptions: false}) }}
                >
                    <Box m={4}>
                        <Heading mb={3}>Add bulk options</Heading>
                        <Textarea
                            placeholder="Add each option on a new line"
                            value={this.state.addBulkOptionsValue}
                            onChange={(e) => this.setState({addBulkOptionsValue: e.target.value})}
                            sx={{minHeight: '200px'}}
                            className="theme-input"
                            autoFocus
                            ></Textarea>

                        <Box mt={3} style={{ textAlign: 'right'}}>
                          <Button variant="tertiary" type='button' mr={2} onClick={() => { this.setState({showAddBulkOptions: false}) }}>
                            Cancel
                          </Button>
                          <Button type='button' variant='primary' mr={0} onClick={this.addOptionsBulk}>Add options</Button>
                        </Box>
                    </Box>
                </ReactModal>

                <ReactTooltip id={`tooltip-reporting_value`} effect="solid" place="top">
                    Setting a Reporting Value displays the answer<br/> option as a "code" in the screener export file.
                </ReactTooltip>
            </div>
        );
    }
}

export default withToastManager(DynamicOptionList);

{/*this.props.canHaveOptionValue && (
    <Box px={2} width={1/2}>
        <Input
            type="text"
            name={`value_${index}`}
            value={val}
            onChange={this.editValue.bind(this, index)}
        />
    </Box>
)*/}
{/* this.props.canHaveOptionValue && this.props.canHaveOptionCorrect &&
<div className="col-sm-1">
  <Input className="form-control" type="checkbox" value="1" onChange={this.editOptionCorrect.bind(this, index)} checked={option.hasOwnProperty('correct')} />
</div> */}
